import {
  AllCandidateBLASTUiParamsType,
  CommonBLASTParamValues,
  MatrixToGapCosts,
  UnwrappedBLASTParamsType,
} from 'search/blast/parameters/common';
import {BLASTMatrix, BLASTPTask} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

export type CandidateBLASTPUiParamsType = Pick<
  AllCandidateBLASTUiParamsType<BLASTPTask>,
  'task' | 'evalue' | 'word_size' | 'culling_limit' | 'gap_cost' | 'matrix' | 'comp_based_stats'
>;

export type BLASTPUiParamsType = UnwrappedBLASTParamsType<CandidateBLASTPUiParamsType>;

const CommonBLASTPParams: Pick<
  CandidateBLASTPUiParamsType,
  'evalue' | 'culling_limit' | 'gap_cost' | 'matrix' | 'comp_based_stats'
> = {
  ...pickDefined(CommonBLASTParamValues, 'matrix', 'evalue', 'culling_limit', 'gap_cost', 'comp_based_stats'),
};

export const DefaultBLASTPParams: CandidateBLASTPUiParamsType = {
  ...CommonBLASTPParams,
  task: {defaultValue: BLASTPTask.BLASTP, values: Object.values(BLASTPTask)},
  word_size: {
    values: [2, 3, 5, 6],
    defaultValue: 3, // from the blastp program, not from NCBI
  },
};

export const DefaultBLASTPShortParams: CandidateBLASTPUiParamsType = {
  ...CommonBLASTPParams,
  task: {defaultValue: BLASTPTask.BLASTPShort, values: Object.values(BLASTPTask)},
  word_size: {
    values: [2, 3, 5, 6],
    defaultValue: 2, // from the blastp program, not from NCBI
  },
};

export const DefaultBLASTPFastParams: CandidateBLASTPUiParamsType = {
  ...CommonBLASTPParams,
  task: {defaultValue: BLASTPTask.BLASTPFast, values: Object.values(BLASTPTask)},
  word_size: {
    values: [2, 3, 5, 6],
    defaultValue: 6, // from the blastp program, not from NCBI
  },
};

export const getCandidateBLASTPUiParams = (
  task?: BLASTPTask,
  matrix?: BLASTMatrix
): CandidateBLASTPUiParamsType => {
  if (!matrix) {
    switch (task) {
      case BLASTPTask.BLASTPShort:
        return DefaultBLASTPShortParams;
      case BLASTPTask.BLASTPFast:
        return DefaultBLASTPFastParams;
      default:
        return DefaultBLASTPParams;
    }
  } else {
    const baseParams = getCandidateBLASTPUiParams(task);
    return {
      ...baseParams,
      matrix: {
        ...baseParams.matrix,
        defaultValue: matrix,
      },
      gap_cost: MatrixToGapCosts[matrix],
    };
  }
};
